import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import { StyleSheet } from "@react-pdf/renderer";
import moment from "moment";
import React from "react";

const classes = makeStyles(theme => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: 200
    },
    flexGrow: 1
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary
  }
}));
// Create styles
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 10
  },
  title: {
    fontSize: 20,
    h3Align: "center",
    marginBottom: 10
  },
  author: {
    fontSize: 12,
    h3Align: "center",
    marginBottom: 5
  },
  image: {
    width: 150,
    marginVertical: 15,
    marginHorizontal: 0
  },
  fecha: {
    fontSize: 12,
    h3Align: "right"
  },
  rangoFecha: {
    fontSize: 12,
    h3Align: "center",
    marginBottom: 5
  },
  rangoFechas: {
    fontSize: 10,
    h3Align: "center"
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableCol70: {
    backgroundColor: "lightblue",
    width: "70%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol30: {
    backgroundColor: "lightblue",
    width: "30%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol70D: {
    backgroundColor: "white",
    width: "70%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol30D: {
    backgroundColor: "white",
    width: "30%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol25: {
    backgroundColor: "lightblue",
    width: "25%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol25D: {
    backgroundColor: "white",
    width: "25%",
    borderStyle: "solid",
    padding: 2,
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol: {
    width: "14%",
    borderStyle: "solid",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCell: {
    margin: "auto",
    marginTop: 5,
    fontSize: 10
  },
  footer: {
    position: "absolute",
    fontSize: 10,
    bottom: 30,
    left: 0,
    right: 0,
    h3Align: "center",
    color: "grey"
  },
  h3Datos: {
    h3Align: "center"
  }
});

// Create Document Component
const MyDocument = props => (
  <div style={styles.body}>
    {console.log(props.data, "data")}
    {console.log(props, "props")}
    <div className={classes.root}>
      <Grid container spacing={0.5}>
        <Grid item xs={12} style={{ textAlign: "center" }}>
          <h2>Informacion General</h2>
        </Grid>
        <Grid item xs={9}>
          <h4>Nombre/Denominacion/Razon Social</h4>
        </Grid>
        <Grid item xs={3}>
          <h4>No. Caso</h4>
        </Grid>
        <Grid item xs={9}>
          <Paper className={classes.paper}>{props.data[0].body}</Paper>{" "}
          {/*****/}
        </Grid>
        <Grid item xs={3}>
          <Paper className={classes.paper}>{props.data[0].title}</Paper>{" "}
          {/*****/}
        </Grid>

        <Grid item xs={9}>
          <h4>Direccion</h4>
        </Grid>
        <Grid item xs={3}>
          <h4>Fecha Alta</h4>
        </Grid>
        <Grid item xs={9}>
          <Paper className={classes.paper}> {props.data[0].domicilio}</Paper>{" "}
          {/*****/}
        </Grid>
        <Grid item xs={3}>
          <Paper className={classes.paper}>
            {props.data[0].creadoFecha
              ? moment(props.data[0].creadoFecha.toDate()).format("DD/MM/YYYY")
              : null}
          </Paper>{" "}
          {/*****/}
        </Grid>

        <Grid item xs={3}>
          <h4>Materia</h4>
        </Grid>
        <Grid item xs={9}>
          <h4>Persona Fisica/Moral Demandada</h4>
        </Grid>
        <Grid item xs={3}>
          <Paper className={classes.paper}>{props.data[0].ramo}</Paper>{" "}
          {/*****/}
        </Grid>
        <Grid item xs={9}>
          <Paper className={classes.paper}>{props.data[0].aseguradora}</Paper>{" "}
          {/*****/}
        </Grid>

        <Grid item xs={3}>
          <h4>Reclamacion</h4>
        </Grid>
        <Grid item xs={9}>
          <h4>Asunto</h4>
        </Grid>
        <Grid item xs={3}>
          <Paper className={classes.paper}>{props.data[0].tiposeguro}</Paper>{" "}
          {/*****/}
        </Grid>
        <Grid item xs={9}>
          <Paper className={classes.paper}>{props.data[0].asunto}</Paper>{" "}
          {/*****/}
        </Grid>

        {/***************************** ETAPA 1*********************************/}
        {props.data[0].fase1 ? (
          <>
            <Grid item xs={12} style={{ textAlign: "center", paddingTop: 35 }}>
              <h2>Etapa 1: Reclamacion Directa</h2>
            </Grid>
            <Grid item xs={3}>
              <h4>No. Siniestro</h4>
            </Grid>
            <Grid item xs={9}>
              <h4>Institucion/Organismo</h4>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase1.numSinsitro
                  ? props.data[0].fase1.numSinsitro
                  : null}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={9}>
              <Paper className={classes.paper}>
                {props.data[0].aseguradora}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <h4>Fecha</h4>
            </Grid>
            <Grid item xs={8}>
              <h4>Descripcion</h4>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Reclamo</Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaReclamo
                  ? moment(props.data[0].fase1.fechaReclamo.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase1.coment1}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Respuesta de reclamo</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaRespueRecl
                  ? moment(props.data[0].fase1.fechaRespueRecl.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase1.coment2}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Informacion Adicional</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaInfoAdici
                  ? moment(props.data[0].fase1.fechaInfoAdici.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase1.coment3}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Entrega Informe Adic.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaEntregInfAdi
                  ? moment(
                      props.data[0].fase1.fechaEntregInfAdi.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase1.coment4}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Entrega Informe Final</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaEntregInfFin
                  ? moment(
                      props.data[0].fase1.fechaEntregInfFin.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase1.coment5}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Respuesta Aseguradora</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaRespFinalAseg
                  ? moment(
                      props.data[0].fase1.fechaRespFinalAseg.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase1.coment6}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Informe Final</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase1.fechaInformeFinal
                  ? moment(
                      props.data[0].fase1.fechaInformeFinal.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase1.coment7}
              </Paper>{" "}
              {/*****/}
            </Grid>{" "}
          </>
        ) : null}
        {/******************************************** ETAPA 2 ***************************/}
        {props.data[0].fase2 ? (
          <>
            <Grid item xs={12} style={{ textAlign: "center", paddingTop: 35 }}>
              <h2>Etapa 2: Reclamacion Administrativa</h2>
            </Grid>

            <Grid item xs={3}>
              <h4>No. Siniestro</h4>
            </Grid>
            <Grid item xs={9}>
              <h4>CONDUSEF</h4>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase2.numExped}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={9}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.condusef}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <h4>Fecha</h4>
            </Grid>
            <Grid item xs={8}>
              <h4>Descripcion</h4>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Admision</Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.fechaAdmis
                  ? moment(props.data[0].fase2.fechaAdmis.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase2.coment1}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Informe via Electronico</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.fechaInfoViaElect
                  ? moment(
                      props.data[0].fase2.fechaInfoViaElect.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase1.coment2}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Audiencia Conciliatoria</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.fechaAudConcil
                  ? moment(props.data[0].fase2.fechaAudConcil.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase2.coment3}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Informe Adicional</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.fechaPrestInofAd
                  ? moment(
                      props.data[0].fase2.fechaPrestInofAd.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase2.coment4}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Audiencia Final</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase2.fechaAudienFinal
                  ? moment(
                      props.data[0].fase2.fechaAudienFinal.toDate()
                    ).format("DD/MM/YYYY")
                  : null}{" "}
                {props.data[0].fase2.coment5}
              </Paper>{" "}
              {/*****/}
            </Grid>
          </>
        ) : null}

        {/*********************** ETAPA 3 MERCANTIL    *****************/}
        {props.data[0].fase3M ? (
          <>
            <Grid item xs={12} style={{ textAlign: "center", paddingTop: 35 }}>
              <h2>Etapa 3: Judicial Ordinaria Mercantil</h2>
            </Grid>

            <Grid item xs={3}>
              <h4>No. Expediente</h4>
            </Grid>
            <Grid item xs={6}>
              <h4>Nombre del Juzgado</h4>
            </Grid>
            <Grid item xs={3}>
              <h4>Tribunal</h4>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3M.numExped}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3M.nombNumJuz}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3M.tribunal}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <h4>Fecha</h4>
            </Grid>
            <Grid item xs={8}>
              <h4>Descripcion</h4>
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Presentacion de Demanda</Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPrestDem
                  ? moment(props.data[0].fase3M.fechaPrestDem.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase3M.coment1}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Radicacion de Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaRadicDem
                  ? moment(props.data[0].fase3M.fechaRadicDem.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment2}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Emplazamiento</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaEmplazam
                  ? moment(props.data[0].fase3M.fechaEmplazam.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment3}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Contestacion de Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaContestDem
                  ? moment(
                      props.data[0].fase3M.fechaContestDem.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment4}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}> Admis. Contest. Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaAdmisConte
                  ? moment(
                      props.data[0].fase3M.fechaAdmisConte.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment5}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={4}>
              <Paper className={classes.paper}>Contest. Vista Contest.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaContVistaConte
                  ? moment(
                      props.data[0].fase3M.fechaContVistaConte.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment6}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Admis. Contest. Vista.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaAdmisConteVist
                  ? moment(
                      props.data[0].fase3M.fechaAdmisConteVist.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment7}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Impugnacion Documento</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaImpugnDoc
                  ? moment(props.data[0].fase3M.fechaImpugnDoc.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment8}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>
                Ofrecimiento de Pruebas Demand.
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaOfrecPrueDem
                  ? moment(
                      props.data[0].fase3M.fechaOfrecPrueDem.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment9}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12} style={{ textAlign: "center", paddingTop: 20 }}>
              <h4>Fechas de pruebas a Desahogar (Admite Actora)</h4> {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Auto Admite Actora</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaAutoAdmiActora
                  ? moment(
                      props.data[0].fase3M.fechaAutoAdmiActora.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment10}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Confesional</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDConfesional
                  ? moment(
                      props.data[0].fase3M.fechaPDConfesional.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Testimonial</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDTestimonial
                  ? moment(
                      props.data[0].fase3M.fechaPDTestimonial.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Declaracion de Parte</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDDecParte
                  ? moment(
                      props.data[0].fase3M.fechaPDDecParte.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Declaracion de Tercero</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDDecTercero
                  ? moment(
                      props.data[0].fase3M.fechaPDDecTercero.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Pericial</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDPericial
                  ? moment(
                      props.data[0].fase3M.fechaPDPericial.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Inspeccion Judicial</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDInspJudic
                  ? moment(
                      props.data[0].fase3M.fechaPDInspJudic.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Reconstruccion de Hechos</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDRecHechos
                  ? moment(
                      props.data[0].fase3M.fechaPDRecHechos.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>
                Ratificacion Contenido y Firma
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPDRatifContFir
                  ? moment(
                      props.data[0].fase3M.fechaPDRatifContFir.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment10*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12} style={{ textAlign: "center" }}>
              <h4>Fechas de pruebas a Desahogar </h4> {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Auto Admite Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaAutoAdmiDeman
                  ? moment(
                      props.data[0].fase3M.fechaAutoAdmiDeman.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment11}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Confesional</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2Confesional
                  ? moment(
                      props.data[0].fase3M.fechaPD2Confesional.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Testimonial</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2Testimonial
                  ? moment(
                      props.data[0].fase3M.fechaPD2Testimonial.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Declaracion de Tercero</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2DecTercero
                  ? moment(
                      props.data[0].fase3M.fechaPD2DecTercero.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Pericial</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2Pericial
                  ? moment(
                      props.data[0].fase3M.fechaPD2Pericial.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Inspeccion Judicial</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2InspJudic
                  ? moment(
                      props.data[0].fase3M.fechaPD2InspJudic.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Reconstruccion de Hechos</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2RecHechos
                  ? moment(
                      props.data[0].fase3M.fechaPD2RecHechos.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>
                Ratificacion Contenido y Firma
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPD2RatifContFir
                  ? moment(
                      props.data[0].fase3M.fechaPD2RatifContFir.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {/*props.data[0].fase3M.coment11*/}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12} style={{ paddingTop: 20 }}>
              <Paper className={classes.paper}> Resumen:{"          "}</Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Apertura Alegatos</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaApertuAleg
                  ? moment(
                      props.data[0].fase3M.fechaApertuAleg.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment12}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Apertura Alegatos</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaApertuAleg
                  ? moment(
                      props.data[0].fase3M.fechaApertuAleg.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment12}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Apertura Alegatos</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaApertuAleg
                  ? moment(
                      props.data[0].fase3M.fechaApertuAleg.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment12}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Citacion Sentencia</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaCitaSent
                  ? moment(props.data[0].fase3M.fechaCitaSent.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment13}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Sentencia Definitiva</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaSentDefin
                  ? moment(props.data[0].fase3M.fechaSentDefin.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment14}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {" "}
                Resumen de resolutivos:{"          "}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Presentacion Rec. Apel.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPresentRecApe
                  ? moment(
                      props.data[0].fase3M.fechaPresentRecApe.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment15}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Reso. Segu. Inst.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaResSegInst
                  ? moment(
                      props.data[0].fase3M.fechaResSegInst.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment16}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Presentacion Amparo</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaPresentAmp
                  ? moment(
                      props.data[0].fase3M.fechaPresentAmp.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3M.coment17}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Ejecutoria Amparo</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaEjecAmp
                  ? moment(props.data[0].fase3M.fechaEjecAmp.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment18}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Cumplimentadora</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3M.fechaCumplim
                  ? moment(props.data[0].fase3M.fechaCumplim.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3M.coment19}
              </Paper>{" "}
              {/*****/}
            </Grid>
          </>
        ) : null}

        {/*********************************** ETAPA 3 ORAL ***********************************/}
        {props.data[0].fase3O ? (
          <>
            <Grid item xs={12} style={{ textAlign: "center", paddingTop: 35 }}>
              <h2>Etapa 3: Judicial Oral Mercantil</h2>
            </Grid>

            <Grid item xs={3}>
              <h4>No. Expediente</h4>
            </Grid>
            <Grid item xs={6}>
              <h4>Nombre del Juzgado</h4>
            </Grid>
            <Grid item xs={3}>
              <h4>Tribunal</h4>
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3O.numExped}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={6}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3O.nombNumJuz}
              </Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={3}>
              <Paper className={classes.paper}>
                {" "}
                {props.data[0].fase3O.tribunal}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <h4>Fecha</h4>
            </Grid>
            <Grid item xs={8}>
              <h4>Descripcion</h4>
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Presentacion de Demanda</Paper>
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaPrestDem
                  ? moment(props.data[0].fase3O.fechaPrestDem.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : null}{" "}
                {props.data[0].fase3O.coment1}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Radicacion de Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaRadicDem
                  ? moment(props.data[0].fase3O.fechaRadicDem.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3O.coment2}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Emplazamiento</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaEmplazam
                  ? moment(props.data[0].fase3O.fechaEmplazam.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3O.coment3}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Contestacion de Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaContestDem
                  ? moment(
                      props.data[0].fase3O.fechaContestDem.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment4}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}> Admis. Contest. Demanda</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaAdmisConte
                  ? moment(
                      props.data[0].fase3O.fechaAdmisConte.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment5}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Contest. Vista Contest.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaContVistaConte
                  ? moment(
                      props.data[0].fase3O.fechaContVistaConte.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment6}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Admis. Contest. Vista.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaAdmisConteVist
                  ? moment(
                      props.data[0].fase3O.fechaAdmisConteVist.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment7}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Audiencia Preliminar</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaAudiePrelim
                  ? moment(
                      props.data[0].fase3O.fechaAudiePrelim.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment8}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Audiencia Juicio</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaAudieJuicio
                  ? moment(
                      props.data[0].fase3O.fechaAudieJuicio.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment9}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Sentencia</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaSentencia
                  ? moment(props.data[0].fase3O.fechaSentencia.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3O.coment10}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Ejecutoria de Amparo</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaEjecuAmpar
                  ? moment(
                      props.data[0].fase3O.fechaEjecuAmpar.toDate()
                    ).format("DD/MM/YYYY")
                  : ""}{" "}
                {props.data[0].fase3O.coment12}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Cumplimentadora</Paper> {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaCumplim
                  ? moment(props.data[0].fase3O.fechaCumplim.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3O.coment13}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper}>
                {" "}
                Resumen Resolutivos: Otros
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={4}>
              <Paper className={classes.paper}>Cumplimentadora Seg.</Paper>{" "}
              {/*****/}
            </Grid>
            <Grid item xs={8}>
              <Paper className={classes.paper}>
                {props.data[0].fase3O.fechaCumplim2
                  ? moment(props.data[0].fase3O.fechaCumplim2.toDate()).format(
                      "DD/MM/YYYY"
                    )
                  : ""}{" "}
                {props.data[0].fase3O.coment14}
              </Paper>{" "}
              {/*****/}
            </Grid>

            <Grid item xs={12}>
              <Paper className={classes.paper}> Resumen: Otros</Paper> {/*****/}
            </Grid>
          </>
        ) : null}
      </Grid>
    </div>
  </div>
);

export default MyDocument;
